import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ProductsService } from 'src/app/providers/services/products.service';
import { Mission } from 'src/app/storage/models/mission.model';
import { ProductMission } from 'src/app/storage/models/product-mission.model';

@Component({
    selector: 'app-update-mission-product',
    templateUrl: './update-mission-product.component.html',
    styleUrls: ['./update-mission-product.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class UpdateMissionProductComponent implements OnInit {

  @Input() params: IUpdateMissionProductParams;
  productExpectedQty: string;

  constructor(
    private productsService: ProductsService
  ) { }

  ngOnInit(): void {
    this.productExpectedQty = this.params.missionProduct.productmissionLoadedExpectedMassTotal.toString();
  }

  close(): void {
    this.params.display = false;
  }

  isValid(): boolean {
    return !isNaN(parseFloat(this.productExpectedQty)) && this.productExpectedQty != null && this.productExpectedQty != '';
  }

  async update(): Promise<void> {
    const productmissionLoadedExpectedMassTotal = parseFloat(this.productExpectedQty)

    const missionProduct: ProductMission = {
      productName: this.params.missionProduct.productName,
      productfamilyname: this.params.missionProduct.productfamilyname,
      productmissionLoadedExpectedMassTotal: productmissionLoadedExpectedMassTotal
    };

    const isUpdated = await this.productsService.updateMissionProduct(this.params.mission, missionProduct);

    if (isUpdated) {
      this.params.missionProduct.productmissionLoadedExpectedMassTotal = productmissionLoadedExpectedMassTotal;
      this.close();
    }
  }

}

export interface IUpdateMissionProductParams {
  display: boolean;
  mission: Mission;
  missionProduct: ProductMission;
}
